import { render, staticRenderFns } from "./default_404.vue?vue&type=template&id=613dca07&scoped=true&lang=pug&"
import script from "./default_404.vue?vue&type=script&lang=js&"
export * from "./default_404.vue?vue&type=script&lang=js&"
import style0 from "./default_404.vue?vue&type=style&index=0&id=613dca07&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613dca07",
  null
  
)

export default component.exports